import { render } from "./AiAssistant.vue?vue&type=template&id=cfa37a28&scoped=true"
import script from "./AiAssistant.vue?vue&type=script&lang=js"
export * from "./AiAssistant.vue?vue&type=script&lang=js"

import "./AiAssistant.vue?vue&type=style&index=0&id=cfa37a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa37a28"]])

export default __exports__